function updateSub(value) {
  document
    .querySelectorAll(
      "#bold-widget > fieldset > div > div.bsub-widget__plans-container > fieldset > div > label > input[type=radio]"
    )
    .forEach(function (element) {
      if (element.value == value) {
        element.checked = true;
        element.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  return;
}
function isSubscribeSelected() {
  var subscribeRadio = document.querySelector(".bold-ro__subscribe-radio-btn");
  return subscribeRadio == null || subscribeRadio.checked;
}

function syncSellingPlanForVariant(selectEl) {
  if (!isSubscribeSelected()) return;

  var selectedIndex = selectEl.selectedIndex;
  var planIds = ["5955780845", "5955813613", "5955944685"];

  if (planIds[selectedIndex]) {
    updateSub(planIds[selectedIndex]);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var productSelect = document.getElementById("productSelect");
  if (!productSelect) return;

  productSelect.addEventListener("change", function (event) {
    syncSellingPlanForVariant(event.target);
  });

  syncSellingPlanForVariant(productSelect);
});
